<template>
  <div id="app">
    <router-view/>
    <cookie-consent />
  </div>
</template>

<script>
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  name: 'App',
  components: {
    CookieConsent
  }
}
</script>

<style>
#app {
  font-family: 'Montserrat', "思源黑体", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2d3748;
}
</style>